import { render, staticRenderFns } from "./ReservationPurposeEdit.vue?vue&type=template&id=a89c70f4&scoped=true&"
import script from "./ReservationPurposeEdit.vue?vue&type=script&lang=js&"
export * from "./ReservationPurposeEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPurposeEdit.vue?vue&type=style&index=0&id=a89c70f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89c70f4",
  null
  
)

export default component.exports